import React, { useEffect, useRef, useState } from 'react';
import iconUpload from '../../images/icon-upload.svg';
import axios from "axios";
import * as securityHelper from "../../helper/SecurityHelper";

export default function SgstRgst({ setBox, setRgst, setSnackbarTxt, auth }: any) {
  const [fileName, setFileName] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const [evntInfo, setEvntInfo] = useState<any>({});
  const [rcptnListData, setRcptnListData] = useState([]);
  const [sgstListData, setSgstListData] = useState<any>([]);
  const [rcptnCd, setRcptnCd] = useState<string>('');
  const [srvCmpnyDataList, setSrvCmpnyDataList] = useState([]);
  const [evntCdList, setEvntCdList] = useState<any>([]);
  const user = securityHelper.getLoginUser();
  const rcptntRef = useRef<any>();
  const sgstGbRef = useRef<any>();
  const cntntsRef = useRef<any>();
  const srvCmpnyRef = useRef<any>();
  const evntSeqRef = useRef<any>();
  const btnRef = useRef<any>();
  const [saving, setSaving] = useState(false);
  const fileHandler = () => { fileRef.current.click(); };
  const [dfltSrvSeq, setDfltSrvSeq] = useState(user.companySeq);
  const [imgSrc, setImgSrc] = useState('');
  const changeHandler = (e: any) => {
    setDfltSrvSeq(e.target.value);
  }

  useEffect(() => {
    let imageSrc;
    if (fileRef.current) {
      const afFileList = fileRef.current.files;
      if (afFileList.length > 0) {
        imageSrc = URL.createObjectURL(afFileList[0]);
        setImgSrc(imageSrc);
      }
    }
  }, [fileName])

  useEffect(() => {
    fn_retrieveTodayWrkDclrEvntCdList();
    fn_retrieveRcptnCdList();
    fn_retrieveSgstCdList();
  }, []);

  const fn_retrieveRcptnCdList = async () => {
    const auth = user.auth;
    let codes;

    if (auth === 'KOX') {
      codes = '002,003';
    } else if (auth === 'COM') {
      codes = '001,003';
    } else if (auth === 'SRV') {
      codes = '001,002';
    }

    const rtrnData = await axios.post('admin/api/cmmn/retriveCmmnCodeList', { codeGrpId: 'T008', codes: codes });
    setRcptnListData(rtrnData.data);
  }
  const fn_retrieveSgstCdList = async () => {
    const rtrnData = await axios.post('admin/api/cmmn/retriveCmmnCodeList', { codeGrpId: 'T009' });
    setSgstListData(rtrnData.data);
  }
  const fn_retrieveTodayPtcptEvntInfo = async (evntSeq: bigint) => {
    const evntInfo = await axios.post("admin/api/sgst/retrieveEvntDtlInfo", { evntSeq: evntSeq })
    setEvntInfo(evntInfo.data);
  }
  const fn_onRcptnSelChg = (e: any) => {
    console.log('22')
    setRcptnCd(e.target.value);
    if (e.target.value === '003') {
      fn_retrieveTodayWrkDclrCmpnyList(evntInfo.seq);
    }
  }
  const fn_onEvntSelChg = (e: any) => {
    fn_retrieveTodayPtcptEvntInfo(e.target.value);
    fn_retrieveTodayWrkDclrCmpnyList(e.target.value);
  }
  const fn_retrieveTodayWrkDclrCmpnyList = async (evntSeq: bigint) => {
    const rtrnData = await axios.post('admin/api/tbm/retrieveTodayWrkDclrCmpnyList', { evntSeq: evntSeq });
    setSrvCmpnyDataList(rtrnData.data);
  }

  useEffect(() => {
    if (evntCdList.length === 1) {
      evntSeqRef.current.value = evntCdList[0].evntSeq;
      fn_retrieveTodayPtcptEvntInfo(evntCdList[0].evntSeq);
    }
  }, [evntCdList])

  const fn_retrieveTodayWrkDclrEvntCdList = async () => {
    const rtrnData = await axios.post('admin/api/sgst/retrieveTodayWrkDclrEvntCdList', { userSeq: user.seq, auth: user.auth, hstCmpnySeq: user.companySeq });
    setEvntCdList(rtrnData.data);
  }

  const fn_saveBtn = () => {
    btnRef.current.setAttribute("readonly", "readonly");
    setSaving(true);
  };

  useEffect(() => {
    if (saving) {
      fn_saveData();
    }
  }, [saving]);

  const fn_saveData = async () => {
    const fileList = fileRef.current.files;
    const formData = new FormData();
    const evntSeq = evntInfo.seq;
    const rcptnGbCd = rcptntRef.current.value;
    const sgstGbCd = sgstGbRef.current.value;
    const prcsStatCd = '001';
    const cntnts = cntntsRef.current.value;
    const rgstrSeq = user.seq;

    let rcptntSeq;
    let srvCmpnySeq;
    let koxCmpnySeq = (await axios.post('admin/api/sgst/retrieveKoxCmpnySeq', {})).data;

    if (rcptnGbCd === '003') {
      srvCmpnySeq = srvCmpnyRef.current.value;
    }

    if (!evntSeq) {
      setSnackbarTxt('행사명을 선택해 주십시오.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      evntSeqRef.current.style.border = 'solid 1.5px rgba(224, 81, 133, 0.5)';
      setTimeout(() => evntSeqRef.current.style.border = 'solid 1px #D9D9D9', 2000);
      return;
    }
    if (!rcptnGbCd) {
      setSnackbarTxt('접수처를 선택해 주십시오.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      rcptntRef.current.style.border = 'solid 1.5px rgba(224, 81, 133, 0.5)';
      setTimeout(() => rcptntRef.current.style.border = 'solid 1px #D9D9D9', 2000);
      return;
    }
    if (rcptnGbCd === '003' && !srvCmpnySeq) {
      setSnackbarTxt('서비스협력업체를 선택해 주십시오.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      srvCmpnyRef.current.style.border = 'solid 1.5px rgba(224, 81, 133, 0.5)';
      setTimeout(() => srvCmpnyRef.current.style.border = 'solid 1px #D9D9D9', 2000);
      return;
    }
    if (!sgstGbCd) {
      setSnackbarTxt('건의 구분을 선택해 주십시오.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      sgstGbRef.current.style.border = 'solid 1.5px rgba(224, 81, 133, 0.5)';
      setTimeout(() => sgstGbRef.current.style.border = 'solid 1px #D9D9D9', 2000);
      return;
    }
    if (!cntnts) {
      setSnackbarTxt('내용을 입력해 주십시오.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      cntntsRef.current.focus();
      return;
    }

    if (rcptnGbCd === '001') {
      rcptntSeq = koxCmpnySeq;
    } else if (rcptnGbCd === '002') {
      rcptntSeq = evntInfo.hstCmpnySeq;
    } else if (rcptnGbCd === '003') {
      rcptntSeq = srvCmpnySeq;
    }

    if (fileList.length > 0) {
      formData.append('multipartFiles', fileList[0]);
    }

    const jsonObject = {
      evntSeq: evntSeq,
      rcptnGbCd: rcptnGbCd,
      sgstGbCd: sgstGbCd,
      prcsStatCd: prcsStatCd,
      cntnts: cntnts,
      rgstrSeq: rgstrSeq,
      rcptntSeq: rcptntSeq,
      rgstCmpnySeq: user.companySeq
    };

    formData.append('jsonData', JSON.stringify(jsonObject));

    const rtrnData = await axios.post('admin/api/sgst/registSgstData', formData);

    if (rtrnData.data > 0) {
      setSnackbarTxt('등록 되었습니다.');
      setTimeout(() => setBox(true), 1000);
      setTimeout(() => setRgst(false), 1000);
    }
  }

  const dataHeaderStyle = 'ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]';

  return (
    <div className={auth !== 'WOK' ? 'bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-118px)] md:h-[calc(100%-295px)] mt-20 md:mt-[50px]'
      : 'bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-74px)] md:h-[calc(100%-185px)]'}>
      <div className='w-[265px] sm:w-[318px] md:w-[750px] mb-25 md:mb-[62px]'>
        <p className='mt-32 ml-7 font-preBold text-15 leading-18 md:mt-[80px] md:ml-[17px] md:text-37 md:leading-[45px]'>신고자 정보</p>
        <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-15 mb-22 md:mt-[37px] md:mb-[55px]' />
        <div
          className="md:relative flex items-center justify-between md:after:w-[20px] md:after:h-[20px] md:after:border-black md:after:border-b-2 md:after:border-r-2 md:after:transform md:after:rotate-45 md:after:absolute md:after:left-[700px] md:after:mb-[10px]">
          <p className={dataHeaderStyle}>행사명</p>
          {user.auth !== 'WOK' ?
          <select ref={evntSeqRef} onChange={fn_onEvntSelChg}
            className='w-[235px] text-14 leading-17 md:w-[587px] md:text-35 md:leading-[42px] outline-none border border-[#D9D9D9] bg-transparent text-txtBlack h-28 md:h-[70px] flex justify-between items-center rounded-[5px] md:rounded-[12px] md:appearance-none md:pl-[37px]'
          >
            <option value=''>선택</option>
            {evntCdList.map((evntCdData: any) => (
              <option key={evntCdData.evntSeq} value={evntCdData.evntSeq}>{evntCdData.evntNm}</option>
            ))}
          </select>
          : evntCdList.map((evntCdData: any) => (
            <><input type='hidden' value={evntCdData.evntSeq} ref={evntSeqRef} />
            <p className='w-[182px] sm:w-[235px] md:w-[587px] text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{evntCdData.evntNm}</p></>
          ))}
        </div>
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>장소</p>
          <p className='w-[235px] text-14 leading-17 md:w-[587px] md:text-35 md:leading-[42px]'>{evntInfo.exbtPlc}</p>
        </div>
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>신고자</p>
          <p className='w-[235px] text-14 leading-17 md:w-[587px] md:text-35 md:leading-[42px]'>{user.name}</p>
        </div>
        <p className='mt-32 ml-7 font-preBold text-15 leading-18 md:mt-[80px] md:ml-[17px] md:text-37 md:leading-[45px]'>건의 내용</p>
        <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-15 mb-22 md:mt-[37px] md:mb-[55px]' />
        <div className='md:relative flex items-center justify-between mt-16 md:mt-[40px] md:after:w-[20px] md:after:h-[20px] md:after:border-black md:after:border-b-2 md:after:border-r-2 md:after:transform md:after:rotate-45 md:after:absolute md:after:left-[700px] md:after:mb-[10px]'>
          <p className={dataHeaderStyle}>접수처</p>
          <select ref={rcptntRef} onChange={fn_onRcptnSelChg} className='w-[235px] text-14 leading-17 md:w-[587px] md:text-35 md:leading-[42px] outline-none border border-[#D9D9D9] bg-white text-txtBlack h-28 md:h-[70px] flex justify-between items-center rounded-[5px] md:rounded-[12px] md:appearance-none md:pl-[37px]'>
            <option value=''>선택</option>
            {rcptnListData.map((rcptnData: any) => (
              <option key={rcptnData.code} value={rcptnData.code}>{rcptnData.codeNm}</option>
            ))}
          </select>
        </div>
        {rcptnCd === '003'
          ? <div className='md:relative flex items-center justify-between mt-7 md:mt-[17px] md:after:w-[20px] md:after:h-[20px] md:after:border-black md:after:border-b-2 md:after:border-r-2 md:after:transform md:after:rotate-45 md:after:absolute md:after:left-[700px] md:after:mb-[10px]'>
            <p className='ml-7 text-14 leading-17 md:ml-[17px] md:text-35 md:leading-[42px] font-preBold whitespace-pre-line'>서비스{'\n'}협력업체</p>
            <select ref={srvCmpnyRef} onChange={changeHandler} value={dfltSrvSeq} className='w-[235px] text-14 leading-17 md:w-[587px] md:text-35 md:leading-[42px] outline-none border border-[#D9D9D9] bg-white text-txtBlack h-28 md:h-[70px] flex justify-between items-center rounded-[5px] md:rounded-[12px] md:appearance-none md:pl-[37px]'>
              <option value=''>선택</option>
              {srvCmpnyDataList.map((cmpnyData: any) => (
                <option key={cmpnyData.cmpnySeq} value={cmpnyData.cmpnySeq}>{cmpnyData.cmpnyNm}</option>
              ))}
            </select>
          </div>
          : null}
        <div className='md:relative flex items-center justify-between mt-7 md:mt-[17px] md:after:w-[20px] md:after:h-[20px] md:after:border-black md:after:border-b-2 md:after:border-r-2 md:after:transform md:after:rotate-45 md:after:absolute md:after:left-[700px] md:after:mb-[10px]'>
          <p className={dataHeaderStyle}>구분</p>
          <select ref={sgstGbRef} className='w-[235px] text-14 leading-17 md:w-[587px] md:text-35 md:leading-[42px] outline-none border border-[#D9D9D9] bg-white text-txtBlack h-28 md:h-[70px] flex justify-between items-center rounded-[5px] md:rounded-[12px] md:appearance-none md:pl-[37px]'>
            <option value=''>선택</option>
            {sgstListData.map((sgstData: any) => (
              <option key={sgstData.code} value={sgstData.code}>{sgstData.codeNm}</option>
            ))}
          </select>
        </div>
        <div className='flex justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>내용</p>
          <textarea ref={cntntsRef} className='w-[235px] h-130 md:w-[587px] md:h-[325px] px-10 pt-10 md:px-[25px] md:pt-[25px] text-14 leading-16 md:text-35 md:leading-[40px] outline-none bg-[#F6F6F8] rounded-[5px] md:rounded-[12px] placeholder:text-14 md:placeholder:text-35 placeholder:text-[#9C9C9B] placeholder:leading-16 md:placeholder:leading-[40px] placeholder:font-preLight ' placeholder='내용을 입력해주세요.' />
        </div>
        <div className='flex justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>사진첨부</p>
          <div className='w-[235px] md:w-[587px]'>
            {!fileName
              ? <button onClick={fileHandler} className='flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>
                <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                <p>사진 올리기</p>
              </button>
              : <><img onClick={fileHandler} src={imgSrc} alt='doneImage' className='object-cover border border-[#D9D9D9] md:w-[65px] md:h-[65px]' />
                <button onClick={fileHandler} className='my-7 md:my-[17px] flex justify-center items-center w-[70%] h-38 md:h-[95px] outline-none border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-gray-400 font-preLight'>
                  <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                  <p>삭제</p>
                </button></>}
          </div>
          <input hidden onChange={(e) => setFileName(e.target.value.substring(12))} type='file' ref={fileRef} />
        </div>
      </div>
      <button onClick={fn_saveBtn} ref={btnRef} className={`font-preLight text-15 md:text-37 text-white w-[265px] sm:w-[318px] md:w-[750px] py-10 md:py-[25px] h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto mb-20 md:mb-[50px]`}>건의사항 등록</button>
    </div>
  );
}

